import Environment from './Environment';
import Theme from './Theme';
import ConnectionUtil from "../util/session/ConnectionUtil";


//@flow
export default class System {
  static APP_NAME_KEY = 'appName';
  static APP_CODE_KEY = 'appCode';
  static ENVIRONMENT_KEY = 'env';
  static THEME_KEY = 'theme';
  static API_BASE_URL = 'apiBaseUrl';
  static PREVIEW_BASE_URL = 'previewBaseUrl';
  static _INSTANCE: System;
  systemStore: Map<string, any>;

  constructor() {
    this.systemStore = new Map();
  }

  put(key: string, value: any) {
    this.systemStore.set(key, value);
  }

  get(key: string): any {
    return this.systemStore.get(key);
  }

  static getInstance(): System {
    return System._INSTANCE;
  }

  static getAppName(): string {
    return this.getInstance().get(System.APP_NAME_KEY);
  }

  static getEnvironment(): Environment {
    return this.getInstance().get(System.ENVIRONMENT_KEY);
  }

  static getTheme(): Theme {
    return this.getInstance().get(System.THEME_KEY);
  }

  /**
   * It would be something like: http://preview-server:8873/review for preview server.
   */
  static getPreviewBaseUrl(): string {
    return this.getInstance().get(this.APP_NAME_KEY);
  }

  static isVAB(): boolean {
    return System.getAppName() === System.APP_NAME.VAB;
  }

  static isDesktop(): boolean {
    let environment = System.getEnvironment();
    return environment.isDesktop();
  }

  static isWebclientApp(): boolean {
    return System.getAppName() === System.APP_NAME.WEBCLIENT;
  }

  static isWebApp(): boolean {
    return System.getAppName() === System.APP_NAME.WEB;
  }

  static isBrowserApp(): boolean {
    let environment = System.getEnvironment();
    return environment.isBrowser();
  }

  static getUnSecureURLCallFromMap() {
    return this.getInstance().get(ConnectionUtil.UNSECURE_REMOTE_CALL_URL);
  }

  static getSecureURLCallFromMap() {
    return this.getInstance().get(ConnectionUtil.SECURE_REMOTE_CALL_URL);
  }

  static SESSION_ENV = {
    VAB: 'VAB',
    WEBCLIENT: 'WEBCLIENT',
    OLD_VAB: 'OLD_VAB',
    WEB: 'WEB'
  };

  static APP_NAME = {
    VAB: 'zm-desktop',
    WEBCLIENT: 'webclient',
    OLD_VAB: 'vab-desktop',
    WEB: 'vab-browser'
  };

}

System._INSTANCE = new System();
